import LogInForm from './LogInForm';

export default LogInForm;
